import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Histologia from './containers/HistologiaTabs';
import Citologia from './containers/citologia';
import Imunologia from './containers/imunologia';
import Arquivamento from './containers/arquivamento';
import * as kanbanActions from './store/kanban.action';
import { rotaEnum } from '@common/util/defaultValues';
import './style.css';
import IntlMessage from "../../helpers/intlMessage";

export default function ModalMoverLote (props) {
  const [modalAberto, setModalAberto] = useState(false);
  const [click, setClick] = useState(false);
  const [componentItem, setcomponentItem] = useState();
  const backdrop = !props.backdrop ? false : props.backdrop;
  const keyboard = props.keyboard === undefined ? true : props.keyboard;

  const kanbanState = useSelector(state => state.kanban);
  const location = useLocation();

  useEffect(() => {
    setcomponentItem(location.pathname.replace('/', ''));
  }, [location]);

  useEffect(() => {
    setModalAberto(kanbanState.modal);
  }, [kanbanState.modal]);

  const dispatch = useDispatch();

  function toggle () {
    setModalAberto(!modalAberto);
    dispatch(kanbanActions.atualizarModal(!modalAberto));
    props.onModal(!modalAberto);
  }

  useEffect(() => {
    if (props.showModal) {
      setModalAberto(props.showModal);
      dispatch(kanbanActions.atualizarModal(props.showModal));
      setClick(false);
    }
  }, [props.showModal]);

  return (
    <Modal
      className='mv-modal-kanban'
      backdrop={backdrop}
      keyboard={keyboard}
      centered
      isOpen={modalAberto}
      toggle={toggle}
    >
      <ModalHeader toggle={!props.close ? toggle : props.close}>
        <IntlMessage id = "dashboards.cytology.listItems"/>
         {props.data.title && props.data.title.text}{' '}
         <IntlMessage id = "dashboards.cytology.toMove"/>
      </ModalHeader>
      <ModalBody>
        {(() => {
          switch (componentItem) {
            case rotaEnum.HISTOLOGIA:
              return (
                <Histologia
                  {...props}
                  click={click}
                  onClick={() => setClick(false)}
                />
              );
            case rotaEnum.CITOLOGIA:
              return (
                <Citologia
                  {...props}
                  onChangePeriodo={props.onChangePeriodo}
                  periodoInicial={props.periodoInicial}
                  periodoFinal={props.periodoFinal}
                  buscar={props.buscar}
                  click={click}
                  onClick={() => setClick(false)}
                />
              );
            case rotaEnum.IMUNOLOGIA:
              return (
                <Imunologia
                  {...props}
                  click={click}
                  onClick={() => setClick(false)}
                />
              );
            case rotaEnum.ARQUIVAMENTO:
              return (
                <Arquivamento
                  {...props}
                  click={click}
                  onClick={() => setClick(false)}
                />
              );
            default:
              return null;
          }
        })()}
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={!props.cancelar ? toggle : props.cancelar}
          className={`button-cancel`}
          color='secondary'
        >
          <IntlMessage id = "dashboards.examDetails.cancel"/>
        </Button>
        <Button
          className={`button-confirm`}
          onClick={() => setClick(true)}
          disabled={kanbanState.moverDisabled}
          color='primary'
        >
          <IntlMessage id = "general.materialArchiving.toMove"/>
        </Button>
      </ModalFooter>
    </Modal>
  );
}



// WEBPACK FOOTER //
// ./src/componentes/dragdrog/modal.js